import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { USER_MGMT_CNST } from '../../../../constants/proj.cnst';
import { countryCodes } from '../../../../constants/country-codes';

import { EnvService } from '../../../../services/env.service';
import { HttpService } from '../../../../services/http.service';
import { UtilsService } from '../../../../services/utils.service';
import { isNullOrUndefined } from '../../../../modules/shared';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-customer-admin',
  templateUrl: './add-customer-admin.component.html',
  styleUrls: ['./add-customer-admin.component.scss']
})
export class AddCustomerAdminComponent implements OnInit {
  @Input() customerId!: string;
  @Input() customerName!: string;
  @Input() customerDetails!: any;
  @Input() operation: string = 'view';
  @Output() dataEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() formEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() customerAdminInfoDetailsEmitter: EventEmitter<any> = new EventEmitter<any>();
  emailPattern: any =  /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
  isEmailValid : boolean = true;

  countryCodeList : any[] = [...countryCodes];

  customerAdminForm: FormGroup = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', []),
    username: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.pattern(this.emailPattern)]),
  });

  primaryMobileForm = new FormGroup({
		primaryMobileNo: new FormControl(undefined, [Validators.required]),
	});

  isPrimaryMobileNoValid : boolean = true;
  currentCountryCode : string = "in";
    constructor(
    private httpSrv: HttpService,
    private utilsSrv: UtilsService,
    private envService : EnvService,
    private router: Router
    ) { }

  ngOnInit() {    
    if((this.operation === 'edit' || this.operation === 'new' )&& this.customerDetails) {
      this.customerAdminForm.get('firstName')?.setValue(this.customerDetails['first_name']);
      this.customerAdminForm.get('lastName')?.setValue(this.customerDetails['last_name']);
      this.customerAdminForm.get('username')?.setValue(this.customerDetails['username']);
      this.customerAdminForm.get('email')?.setValue(this.customerDetails['email_id']);
      this.primaryMobileForm.get('primaryMobileNo')?.setValue(this.customerDetails['mobile_number']);
      this.customerAdminForm.disable();
      this.primaryMobileForm.disable();

      this.formEmitter.emit(this.customerAdminForm);
    }
    
    this.customerAdminForm.valueChanges.subscribe((value:any) => {
      this.formEmitter.emit(this.customerAdminForm);

    })
  }

  
  navigateToCustomerList() {
    this.router.navigate(['um', 'customer']);
  }

  navigateToEdit() {
    this.router.navigate(['um', 'customer', 'addCustomer'], {
      queryParams: {
        operation: 'edit'
      },
      queryParamsHandling: 'merge'
    })
  }

  onlyAlphabet(event: any) {
    const pattern = /[a-zA-Z]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  allowOnlyNumbers(event: any) {
    const pattern = /[0-9\+\-\ ]/;

    let inputChar = String.fromCharCode(event.charCode);

    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  validateEmail(event: any) {
    let inputStr = event.target.value;
    this.isEmailValid = this.utilsSrv.isEmailValid(this.emailPattern, inputStr);
  }

  onlyLowerCaseAlphabet(event: any) {
    // const pattern = /[a-z]/;
    const pattern = /^[a-z0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]+$/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  addOrEditCustomerAdmin() {
    if(!this.customerDetails) {
      this.addCustomerAdmin()
    }else {
      this.formEmitter.emit(this.customerAdminForm);
      this.dataEmitter.emit(true);
      return;
    }
  }

  addCustomerAdmin(){
    if (this.customerAdminForm.invalid) {
      return;
    }
    //* Create post data for add user
    const postdata = this.postDataCreationForAddUser();
    //* Api call for add user
    this.httpSrv.makePostApiCall('ADD_USER', postdata, this.envService.baseUrl).subscribe({
      next: (res: any) => {
        if (res.result) {
          this.updateUser(res.response, postdata);
        } else {
          this.utilsSrv.showToastMessage(
            USER_MGMT_CNST.ERROR_MESSAGES.CUST_ADMIN_GENERAL,
            "error"
          );
        }
        this.dataEmitter.emit(true);
      },

      complete: () => {
        const {firstName ,lastName, username,mobileNo,email}=postdata.metaInfo;
        const obj={firstName ,lastName, username,mobile_number:mobileNo,email_id:email};
        this.customerAdminInfoDetailsEmitter.emit(obj);
      },
      error: (err: any) => {
        let errorMessage = USER_MGMT_CNST.ERROR_MESSAGES.CUST_ADMIN_GENERAL;

        if (!isNullOrUndefined(err)) {

          if (!isNullOrUndefined(err.error.message)) {

            let { KEYCLOAK_ERROR_MSGS } = USER_MGMT_CNST;

            if (err.error.message.startsWith(`${KEYCLOAK_ERROR_MSGS.incomingMobileNoError} '${postdata['metaInfo']['mobileNo']}'`)) {
              errorMessage = KEYCLOAK_ERROR_MSGS.displayedmobileNoErrorMsg;
            } else {
              if(err.error.message.includes('users_mobile_number_key')) {
                errorMessage = "Mobile Number Already Exists";
              }else {
                errorMessage = err.error.message;
              }
            }

          } else {

            let errorText = err.split(USER_MGMT_CNST.CONFLICT_STRING)[1];

            if (!isNullOrUndefined(errorText) && errorText !== '') {
              errorText = JSON.parse(errorText);
              errorMessage = errorText[0]["errorMessage"];
            }
          }
        }

        this.utilsSrv.showToastMessage(errorMessage, "error");
        this.dataEmitter.emit(false);
      }
    });
  }

  checkLength(event: any) {
   
    let value = event.target.value;
    const indexOfPlus = (this.primaryMobileForm.getRawValue()?.primaryMobileNo as any).indexOf('+');
    let dialCode = (this.primaryMobileForm.getRawValue()?.primaryMobileNo as any).slice(0, indexOfPlus + 3);
    let phoneNumberPart:any = (this.primaryMobileForm.getRawValue()?.primaryMobileNo as any).slice(indexOfPlus + 3);
    if(dialCode == '+91' && !(phoneNumberPart.toString().length === 10)){
      this.isPrimaryMobileNoValid = false;
      this.primaryMobileForm.get('primaryMobileNo')?.setValue(undefined);
      this.primaryMobileForm.get('primaryMobileNo')?.updateValueAndValidity();
      return;
    }
    if (value.length > 0) {
      this.isPrimaryMobileNoValid = this.primaryMobileForm.invalid ? false : true;
    } else {
      this.isPrimaryMobileNoValid = true;
    }
  }

  //* post data creation for add user
  postDataCreationForAddUser(){
    const postdata = {
      metaInfo: {
        "username": this.customerAdminForm.value.username,
        "firstName": this.customerAdminForm.value.firstName,
        "lastName": this.customerAdminForm.value.lastName,
        "email": this.customerAdminForm.value.email,
        "mobileNo": this.primaryMobileForm.controls['primaryMobileNo'].value,
        "customerId": this.customerId,
        "customerName": this.customerName
      }
    }

    return postdata;
  }


  updateUser(userId: any, addUserPostData : any) {

    let postData = {
      "metaInfo": null,
      "addRoles": USER_MGMT_CNST.EDIT_USER_ADD_ROLE,
      "updateRoles": {},
      "deleteRoles": [],
      "userId": userId
    }
    this.httpSrv.makePutApiCall('UPDATE_USER', postData, this.envService.baseUrl, { uriParams: { userId } }).subscribe({
      next: (res: any) => {
        this.utilsSrv.showToastMessage("Customer's Admin Added Successfully", "success");
      },
      error: () => {
        this.utilsSrv.showToastMessage("Error occured while creating customer admin", "error");
      }
    });
  }

  onPaste(event: ClipboardEvent,key : string) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData?.getData('text');
    let trimmedText = key == 'username'? pastedText?.replace(/[^a-z]/g, ''): pastedText?.replace(/[^a-zA-Z]/g, '');
    setTimeout(() => {
      trimmedText = trimmedText?.substr(0,25);
      this.customerAdminForm.patchValue({
        [key]: trimmedText
      });
    }, 1);
  }
}
